import React from 'react'
import styled from 'styled-components'

import type {NavatticEvent} from '@helios/shared/types/navattic-event'
import {track, TrackingEvent} from '@helios/shared/utils/analytics'

type NavatticDemoProps = {
    title: string
    src: string
    tabIndex?: number
    style?: React.CSSProperties
    onIFrameReady?: () => void
    onNavigate?: (url: string) => void
}

const NavatticDemo = ({onIFrameReady, onNavigate, ...rest}: NavatticDemoProps) => {
    React.useEffect(() => {
        const handleNavatticEvents = (event: MessageEvent<NavatticEvent>) => {
            if (event.origin !== 'https://pleo.navattic.com') {
                return
            }

            if (onIFrameReady && event.data.kind === 'navattic:stylesheetsLoaded') {
                onIFrameReady()
            }

            if (event.data.kind === 'navattic:event') {
                track(TrackingEvent.NavatticEvent, {...event.data})

                if (
                    onNavigate &&
                    event.data.event === 'NAVIGATE' &&
                    event.data.url.endsWith('/register')
                ) {
                    onNavigate(event.data.url)
                }
            }
        }

        window.addEventListener('message', handleNavatticEvents)

        return () => window.removeEventListener('message', handleNavatticEvents)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return <StyledIFrame {...rest} />
}

const StyledIFrame = styled.iframe`
    width: 100%;
    height: 100%;
    border: none;
`

export default NavatticDemo
